var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var AuthWidget = function () {
            function AuthWidget(params) {
                _classCallCheck(this, AuthWidget);

                this.links = params.links ? params.links : null;
                this.labels = params.labels ? params.labels : null;
                this.isFromBooking = params.isFromBooking ? params.isFromBooking : false;
                this.isPartnerAuth = params.isPartnerAuth ? params.isPartnerAuth : false;
                this.isFirstAuth = false;
                this.authPlace = 'booking';

                this.mask = null;

                this.initPhoneMask();

                this.handlers();
                this.codeInputsHandler();
            }

            _createClass(AuthWidget, [{
                key: "initPhoneMask",
                value: function initPhoneMask() {
                    this.mask = IMask(document.querySelector('#js-phone-inputmask'), {
                        mask: '(000) 000-00-00',
                        definitions: {
                            X: {
                                mask: '0',
                                displayChar: 'X',
                                placeholderChar: '#'
                            }
                        },
                        lazy: false,
                        overwrite: 'shift'
                    });
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    /** Этой хуйне тут не место надо куда то вынести потом **/
                    eventDispatcher.addEvent('click', '.js-modal-toggle', function () {
                        window.brxTracking.setYaEvent('DesktopBookOnline.ModalCall');
                    });

                    eventDispatcher.addAllEvent('keydown', '#js-phone-inputmask', function (event) {
                        // Проверяем, была ли нажата клавиша Enter
                        if (event.key === 'Enter') {
                            // Получаем ссылку на кнопку
                            var btnSendCode = document.querySelector('.js-send-code');
                            // Вызываем метод click() для кнопки
                            btnSendCode.click();
                        }
                    });

                    eventDispatcher.addAllEvent('change', '#s_countryPhoneCode', function (event) {
                        var target = event.target;
                        var select = target.closest('.pseudo-select');
                        var option = select.querySelector('.options div[data-value="' + target.value + '"]');

                        if (option) {

                            var phone = document.querySelector('.auth-form__phone');
                            if (phone) {
                                phone.value = '';
                            }

                            _this.mask.updateOptions({
                                mask: option.querySelector('.code').dataset.mask.replace(/9/g, '0')
                            });
                            _this.mask.updateValue();
                        }
                    });

                    eventDispatcher.addAllEvent('click', '.js-send-code', function (e) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: e.currentTarget,
                            isShow: true
                        });

                        window.brxTracking.setYaEvent('BookOnlineAuthModal.NumberSent');

                        if (_this.isPartnerAuth) {
                            _this.sendAuthRequest({
                                phone: document.querySelector('.auth-form__phone').value,
                                code: document.querySelector('.countryPhoneCode').value,
                                source: document.querySelector('.auth-partners-page').dataset.source,
                                companyId: document.querySelector('.auth-partners-page').dataset.id
                            });
                        } else {
                            var codeValue = document.querySelector('.countryPhoneCode').value;
                            var code = codeValue.trim().replace(/^[_+]+|[_+]+$/g, '');

                            _this.sendAuthRequest({
                                phone: document.querySelector('.auth-form__phone').value,
                                code: code
                            });
                        }
                    });

                    eventDispatcher.addAllEvent('click', '.js-login', function (e) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: e.currentTarget,
                            isShow: true
                        });

                        var inputElements = document.querySelectorAll('.js-input-code-item');
                        var values = Array.from(inputElements).map(function (input) {
                            var parsedValue = parseInt(input.value, 10);

                            // Проверяем, является ли значение числом и не пустым
                            if (!isNaN(parsedValue)) {
                                return parsedValue;
                            } else {
                                return null; // Если не число или пусто, добавляем null в массив
                            }
                        });

                        values = values.filter(function (value) {
                            return value !== null;
                        });

                        var combinedValue = values.join('');

                        var obPage = document.querySelector('.online-booking-page');

                        var loginData = {
                            phone: document.querySelector('.auth-form__phone').value,
                            code: document.querySelector('.countryPhoneCode').value,
                            smsCode: combinedValue,
                            authPlace: _this.authPlace
                        };

                        if (obPage) {
                            loginData.tourId = obPage.dataset.id;
                        }

                        _this.sendLoginRequest(loginData);
                        _this.authPlace = 'booking';
                    });

                    eventDispatcher.addAllEvent('click', '.js-btn-resend-code', function (event) {
                        var target = event.target;
                        var element = document.querySelector('.js-send-code');
                        var clickEvent = new Event('click');
                        target.disabled = true;

                        element.dispatchEvent(clickEvent);

                        _this.codeResendCounter(target);
                    });

                    eventDispatcher.addAllEvent('click', '.js-btn-change-phone', function (event) {
                        var target = event.target;
                        var panelPhone = document.querySelector('.auth-phone-panel');
                        var panelCode = document.querySelector('.auth-code-panel');
                        panelPhone.classList.remove('hide');
                        panelCode.classList.add('hide');
                    });

                    eventDispatcher.addEvent('click', '.js-registration-partner', function (e) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: e.currentTarget,
                            isShow: true
                        });

                        var params = {
                            firstName: document.querySelector('[name="firstName"]').value,
                            secondName: document.querySelector('[name="secondName"]').value,
                            iin: document.querySelector('[name="iin"]').value
                        };

                        _this.sendRegistrationRequest(params);
                    });

                    eventDispatcher.addEvent('click', '.js-btn-after-auth', function (e) {
                        window.location.href = _this.links.afterPartnerAuthLink;
                    });
                }
            }, {
                key: "codeInputsHandler",
                value: function codeInputsHandler() {
                    var inputs = document.querySelectorAll('.js-input-code-item');
                    inputs.forEach(function (item, index, array) {
                        item.addEventListener('keydown', function (event) {
                            // Получаем текущее значение поля
                            var value = item.value;

                            // Если нажата клавиша backspace
                            if (event.key === 'Backspace') {
                                event.preventDefault();
                                // Если значение поля пустое, и это не первое поле, переходим на предыдущее поле
                                if (value === '' && index > 0) {
                                    array[index - 1].focus();
                                    array[index - 1].value = '';
                                } else {
                                    // Иначе стираем символ из текущего поля
                                    item.value = '';
                                }
                            }
                        });

                        // Следим за событием ввода
                        item.addEventListener('input', function () {
                            // Если введен символ и есть следующее поле
                            if (item.value !== '' && index < array.length - 1) {
                                // Устанавливаем фокус на следующем поле
                                array[index + 1].focus();
                            } else if (index === array.length - 1 && item.value !== '') {
                                // Если текущее поле последнее и введено значение, нажимаем на кнопку
                                var btnLogin = document.querySelector('.js-login');
                                btnLogin.click();
                            }
                        });
                    });
                }
            }, {
                key: "sendAuthRequest",
                value: function sendAuthRequest(params) {
                    var _this2 = this;

                    var hint = document.querySelector('.js-phone-panel-hint');
                    hint.classList.remove('error');

                    if (!this.isPartnerAuth) {
                        hint.textContent = this.labels.phonePanel.hint;
                    }

                    var inputGroup = document.querySelector('.js-input-group');
                    inputGroup.classList.remove('error');

                    ajax.post(this.links.authLink, { params: params }, function (data) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: document.querySelector('.js-send-code'),
                            isShow: false
                        });

                        if (data.success) {
                            var panelPhone = document.querySelector('.auth-phone-panel');
                            var panelCode = document.querySelector('.auth-code-panel');
                            var title = panelCode.querySelector('.js-title');
                            title.innerHTML = _this2.labels.codePanel.title + '<br> +' + params.code + ' ' + params.phone;
                            panelPhone.classList.add('hide');
                            panelCode.classList.remove('hide');
                            var codeInputs = document.querySelectorAll('.js-input-code-item');
                            codeInputs[0].focus();
                            window.brxTracking.sendAnalyticsEvent('next_step_to_book_number_sent');
                        } else {
                            var errors = Object.values(data.errors);

                            if (errors.length > 0) {
                                hint.classList.add('error');
                                hint.textContent = errors[0];
                                inputGroup.classList.add('error');
                            }
                        }
                    });
                }
            }, {
                key: "sendLoginRequest",
                value: function sendLoginRequest(data) {
                    var _this3 = this;

                    var hint = document.querySelector('.js-panel-code-hint');
                    hint.classList.remove('error');

                    if (!this.isPartnerAuth) {
                        hint.textContent = this.labels.codePanel.hint;
                    }

                    var inputList = document.querySelector('.js-auth-input-list');
                    inputList.classList.remove('error');

                    ajax.post(this.links.loginLink, { params: data }, function (data) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: document.querySelector('.js-login'),
                            isShow: false
                        });

                        if (data.success) {
                            if (_this3.isPartnerAuth) {
                                _this3.authPlace = 'partner-page';
                            }

                            var eventProperties = {};
                            eventProperties['Place'] = _this3.authPlace;
                            window.brxTracking.sendAnalyticsEvent('next_step_to_book_auth_success', eventProperties);

                            if (data.responseData && data.responseData.link) {
                                window.location.href = data.responseData.link;
                                return;
                            }

                            if (_this3.isPartnerAuth) {
                                if (_this3.isFirstAuth) {
                                    _this3.showRegistrationForm();
                                } else {
                                    _this3.showSuccessContent();
                                }
                            } else {
                                _this3.addHotelToWishlist();
                                _this3.redirectLink();
                            }
                        } else {
                            var errors = Object.values(data.errors);

                            if (errors.length > 0) {
                                hint.classList.add('error');
                                hint.textContent = errors[0];

                                inputList.classList.add('error');
                            }
                        }
                    });
                }
            }, {
                key: "redirectLink",
                value: function redirectLink() {
                    var urlParams = new URLSearchParams(window.location.search);
                    var backUrl = urlParams.get('backUrl');
                    if (backUrl) {
                        window.location.href = backUrl;
                    } else {
                        window.location.href = this.links.afterLoginRedirectLink;
                    }
                }
            }, {
                key: "sendRegistrationRequest",
                value: function sendRegistrationRequest(params) {
                    var _this4 = this;

                    this.clearRegistrationErrors();

                    eventDispatcher.dispatchEvent('toggleBtnLoading', {
                        target: document.querySelector('.js-registration-partner'),
                        isShow: false
                    });

                    ajax.post(this.links.registrationLink, { params: params }, function (data) {
                        if (data.errors) {
                            _this4.displayErrors(data.errors);
                        } else {
                            _this4.showSuccessContent();
                        }
                    });
                }
            }, {
                key: "codeResendCounter",
                value: function codeResendCounter(element) {
                    element.innerHTML = this.labels.controls.resendCodeThrough + ':' + '<span id="code-counter">59</span>';

                    var counterElement = document.getElementById('code-counter');

                    // Проверяем, есть ли сохраненное время начала в localStorage
                    var startTime = localStorage.getItem('startTimeCodeCounter');

                    // Если время начала не сохранено или прошло более 60 секунд, начинаем заново
                    if (!startTime || Date.now() - startTime > 60000) {
                        startTime = Date.now();
                        localStorage.setItem('startTimeCodeCounter', startTime.toString());
                    }

                    // Получаем разницу между текущим временем и временем начала в секундах
                    var initialDiffInSeconds = Math.floor((Date.now() - startTime) / 1000);

                    var counterValue = 59 - initialDiffInSeconds;

                    // Если счетчик становится отрицательным, устанавливаем его в 0
                    if (counterValue < 0) {
                        counterValue = 0;
                    }

                    counterElement.textContent = counterValue;

                    var intervalId = setInterval(function () {
                        counterValue--;

                        counterElement.textContent = counterValue;

                        if (counterValue === 0) {
                            clearInterval(intervalId);
                            element.disabled = false;
                            element.querySelector('#code-counter').remove();
                            element.textContent = this.labels.controls.resendCode;
                        }
                    }, 1000);
                }
            }, {
                key: "showSuccessContent",
                value: function showSuccessContent() {
                    var companyName = document.querySelector('.auth-success-company-name');
                    companyName.textContent = document.querySelector('.auth-partners-page').dataset.name;

                    var panelCode = document.querySelector('.auth-code-panel');
                    panelCode.classList.add('hide');

                    var successAuth = document.querySelector('.auth-success-content');
                    successAuth.classList.remove('hide');

                    var registration = document.querySelector('.auth-partners-registration-form');
                    registration.classList.add('hide');
                }
            }, {
                key: "showRegistrationForm",
                value: function showRegistrationForm() {
                    var panelCode = document.querySelector('.auth-code-panel');
                    panelCode.classList.add('hide');
                    var registration = document.querySelector('.auth-partners-registration-form');
                    registration.classList.remove('hide');
                    if (this.authPlace === 'one-click-popup') {
                        // для формы забронировать в 1 клик скрываем авторизацию через halyk id
                        var halykAuthButton = document.querySelector('.default-halyk-sing-in-button');
                        if (halykAuthButton) {
                            halykAuthButton.classList.add('hide');
                        }
                    }
                }
            }, {
                key: "clearRegistrationErrors",
                value: function clearRegistrationErrors() {
                    var errorElements = document.querySelectorAll('.error-message');
                    errorElements.forEach(function (element) {
                        return element.remove();
                    });

                    document.querySelectorAll('.form-group').forEach(function (e) {
                        e.classList.remove('error');
                    });
                }
            }, {
                key: "displayErrors",
                value: function displayErrors(errors) {
                    if (errors.firstName) {
                        this.showError(document.querySelector('[name="firstName"]'), errors.firstName);
                    }
                    if (errors.secondName) {
                        this.showError(document.querySelector('[name="secondName"]'), errors.secondName);
                    }
                    if (errors.iin) {
                        this.showError(document.querySelector('[name="iin"]'), errors.iin);
                    }
                }
            }, {
                key: "showError",
                value: function showError(inputElement, errorMessage) {
                    // Создать элемент для отображения ошибки
                    var errorElement = document.createElement('div');
                    errorElement.className = 'error-message';
                    errorElement.textContent = errorMessage;

                    // Вставить элемент после поля ввода
                    inputElement.parentNode.insertBefore(errorElement, inputElement.nextSibling);

                    inputElement.closest('.form-group').classList.add('error');
                }
            }, {
                key: "addHotelToWishlist",
                value: function addHotelToWishlist() {
                    var urlParams = new URLSearchParams(window.location.search);
                    var fromWishlist = urlParams.get('fromHotelWishlist');
                    var hotelId = urlParams.get('hotelId');

                    if (fromWishlist && hotelId) {
                        var addWishlistHotelLink = '/new/wishlist/add-wishlist-hotel';

                        ajax.post(addWishlistHotelLink + "?hotelId=" + hotelId, {}, function () {});
                    }
                }
            }]);

            return AuthWidget;
        }();

        window.AuthWidget = AuthWidget;
    }, {}] }, {}, [1]);